import { startTransition, StrictMode } from 'react';
import { HydratedRouter } from 'react-router/dom';

import { hydrateRoot } from 'react-dom/client';

/**
 * This is a client-side entry point for React Router.
 * This file was created with `npx react-router reveal`.
 *
 * You can use this file to remove StrictMode for debugging.
 *
 * With our setup, we need StrictMode disabled in dev, to see
 * drawer closing on navigating with back button.
 */

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
